"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = exports.COLORS = void 0;
var Icon_1 = require("./Icon");
Object.defineProperty(exports, "COLORS", { enumerable: true, get: function () { return Icon_1.COLORS; } });
Object.defineProperty(exports, "Icon", { enumerable: true, get: function () { return Icon_1.Icon; } });
